import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect, lazy, Suspense } from 'react';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import CookieBanner from './components/CookieBanner';
import Home from './pages/Home';
const DynamicPricing = lazy(() => import('./pages/DynamicPricing'));
const GoogleShopping = lazy(() => import('./pages/GoogleShopping'));
const MarketplaceMonitoring = lazy(() => import('./pages/MarketplaceMonitoring'));
const CompetitorMonitoring = lazy(() => import('./pages/CompetitorMonitoring'));
const PriceMonitoring = lazy(() => import('./pages/PriceMonitoring'));
const MapAlerts = lazy(() => import('./pages/MapAlerts'));
const DataExtraction = lazy(() => import('./pages/DataExtraction'));
const Resources = lazy(() => import('./pages/Resources'));
const BlogPost = lazy(() => import('./pages/BlogPost'));
const Pricing = lazy(() => import('./pages/Pricing'));
const Contact = lazy(() => import('./pages/Contact'));
const Trial = lazy(() => import('./pages/Trial'));
const PrivacyPolicy = lazy(() => import('./pages/PrivacyPolicy'));
const TermsConditions = lazy(() => import('./pages/TermsConditions'));
const ColorPicker = lazy(() => import('./pages/ColorPicker'));
const Admin = lazy(() => import('./pages/Admin'));
const Help = lazy(() => import('./pages/Help'));
const Unsubscribe = lazy(() => import('./pages/Unsubscribe'));
const NotFound = lazy(() => import('./pages/NotFound'));

const COOKIE_KEY = 'sap_cookie_consent';
const GA_ID = process.env.REACT_APP_GA_ID;

function GATracker() {
  const location = useLocation();
  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_KEY);
    if (consent !== 'accepted' || !GA_ID || !window.gtag) return;
    window.gtag('config', GA_ID, { page_path: location.pathname + location.search });
  }, [location]);
  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <GATracker />
      <div className="min-h-screen flex flex-col">
        <Navbar />
        <main className="flex-grow">
          <Suspense fallback={<div className="min-h-screen" />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/dynamic-pricing" element={<DynamicPricing />} />
            <Route path="/google-shopping" element={<GoogleShopping />} />
            <Route path="/marketplace-monitoring" element={<MarketplaceMonitoring />} />
            <Route path="/competitor-monitoring" element={<CompetitorMonitoring />} />
            <Route path="/price-monitoring" element={<PriceMonitoring />} />
            <Route path="/map-alerts" element={<MapAlerts />} />
            <Route path="/data-extraction" element={<DataExtraction />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/blogs/:slug" element={<BlogPost />} />
            <Route path="/help" element={<Help />} />
            <Route path="/help/:slug" element={<BlogPost />} />
            <Route path="/updates/:slug" element={<BlogPost />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/trial" element={<Trial />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-conditions" element={<TermsConditions />} />
            <Route path="/colors" element={<ColorPicker />} />
            <Route path="/sapadmin" element={<Admin />} />
            <Route path="/unsubscribe" element={<Unsubscribe />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          </Suspense>
        </main>
        <Footer />
        <CookieBanner />
      </div>
    </Router>
  );
}

export default App;